var exports = {
  "kL": "x43aef4ae--32e4dc--container",
  "Qs": "x43aef4ae--32e4dc--content",
  "ed": "x43aef4ae--32e4dc--disclaimer",
};

module.exports = exports;
